import React from 'react';
import PropTypes from 'prop-types';
import './ImageChooser.scss';

class ImageChooser extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            src: ""
        }
    }

    handleChange = () => {
        let file = document.querySelector('input[type=file]').files[0];
        let reader = new FileReader();

        reader.onloadend = () => {
            this.setState({ src: reader.result });
        };

        if (file) {
            reader.readAsDataURL(file);
            this.props.onChange(file);
        }
    }

    render() {
        return (
            <div>
                <div className="image-chooser" style={{ backgroundColor: this.props.backgroundColor }}>
                    {this.state.src && (
                        <img id="imageChooser" src={this.state.src} alt="Default Image" />
                    )}
                    {!this.state.src && this.props.defaultImage && (
                        <img id="imageChooser" src={this.props.defaultImage} alt="Default Image" />
                    )}
                    {!this.state.src && !this.props.defaultImage && this.props.imageUrl && (
                        <img id="imageChooser" src={this.props.imageUrl} alt="Image URL" />
                    )}
                </div>
                <div className="mb-3">
                    <input type="file" className="form-control-file" id={this.props.name} onChange={this.handleChange} />
                </div>
            </div>
        )
    }
}

ImageChooser.propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    backgroundColor: PropTypes.string,
    defaultImage: PropTypes.string,
    imageUrl: PropTypes.string,
    onChange: PropTypes.func
};

export default ImageChooser;
